const initialState = {
    applicationList:[],
    initialized:false,
    title:'Applications'
}

export default function dashboard(state = initialState, action) {
switch (action.type) {
    case "DASHBOARD_FETCH_FULFILLED":
    return{...state,
        applicationList:action.payload.data,
        initialized:true,
        title:action.appType==='APP'?"Applications":state.title
    }
    case "APP_DETAIL_FULFILLED":
    return{...state,
        title:action.payload.data.name
    }
    case "APP_DETAIL_INIT":
    return{...state,
        title:action.payload
    }
    default:
        return state
    }
}